import { render, staticRenderFns } from "./CritereTypeTiers.vue?vue&type=template&id=2b7190d8"
import script from "./CritereTypeTiers.vue?vue&type=script&lang=js"
export * from "./CritereTypeTiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports